import type { TourStep } from '@/components/ui/Tour';
import { LESSON_SESSION_TOUR_STEP_IDS } from '../tour-constants';
import { TourStepContent } from './StepContent';

/** Session detail drawer — coaches, students, attendance, and session actions. */
export const lessonSessionDetailTourSteps: TourStep[] = [
  {
    content: (
      <TourStepContent
        title="Lesson session drawer"
        description="Open any lesson on the calendar to manage this date — coaches, students, attendance, and session actions without leaving the schedule."
      />
    ),
    selectorId: LESSON_SESSION_TOUR_STEP_IDS.DRAWER,
    position: 'left',
  },
  {
    content: (
      <TourStepContent
        title="Session overview"
        description="See the lesson name, date, time, age group, sport, and whether this occurrence is scheduled, cancelled, or postponed."
      />
    ),
    selectorId: LESSON_SESSION_TOUR_STEP_IDS.OVERVIEW,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Coaches on this session"
        description="Review assigned coaches, add a cover coach for this date only, and mark coach attendance when your academy uses it."
      />
    ),
    selectorId: LESSON_SESSION_TOUR_STEP_IDS.COACHES,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Students this session"
        description="View who is enrolled for this date, add students, confirm pending bookings, and mark student attendance."
      />
    ),
    selectorId: LESSON_SESSION_TOUR_STEP_IDS.STUDENTS,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Session actions"
        description="Edit the lesson, postpone or cancel this occurrence, share the lesson link, or remove the session from the schedule."
      />
    ),
    selectorId: LESSON_SESSION_TOUR_STEP_IDS.ACTIONS,
    position: 'top',
  },
];
